import type { NavbarProps } from '../../pages/page/NavbarProps.d';

import React from 'react';
import { Navbar } from '/react4xp/pages/page/Navbar';


export default function (props: NavbarProps): JSX.Element {
	return <Navbar {...props} />;
}
